import {Component, EventEmitter, Input, Output} from '@angular/core';
import {debounceTime, distinctUntilChanged, Observable, of, tap} from "rxjs";
import {NominativeInfo} from "../../core/interfaces/name-list.interface";
import {catchError, map} from "rxjs/operators";
import {BaseSelect} from "../../core/classes/base.component";
import {ItemCrudInfo} from "../../core/interfaces/item.interface";
import {ItemCrudService} from "../../core/services/routes-services/itemCrud.service";
import {isNonNullString} from "../../core/classes/Utils";
import {BomType} from "../../core/interfaces/admin.interface";

@Component({
    selector: 'app-item-select',
    exportAs: 'ngModel',
    templateUrl: './item-select.component.html',
    styleUrls: ['./item-select.component.scss']
})
export class ItemSelectComponent extends BaseSelect<ItemCrudInfo> {

    @Output()
    clearSearchOnAddVal: boolean = false
    @Output()
    deselectOnClickVal: boolean = false

    @Output() selectionChanged = new EventEmitter<any>();

    @Input()
    bomType: BomType = null

    constructor(
        private _service: ItemCrudService,
    ) {
        super(true)
    }

    trackByFn(item: NominativeInfo) {
        return item.id;
    }

    override executeRequest(term): Observable<any> {
        if(isNonNullString(term)) {
            return this._service.filter(term, this.request()).pipe(
                distinctUntilChanged(),
                debounceTime(200),
                map(res => {
                    return res.data as ItemCrudInfo[]
                }),
                catchError(() => of([])), // empty list on error
                tap(() => (this.loading = false)),
            )
        }
        this.loading = false
        return of([])
    }

    formatSupplierData(item) {
        let res = ''
        if(item.data.supplier != null) {
            res = '[' + item.data.supplier.name
            if(item.data.price != null)
                res = res + ' - Prezzo: ' + item.data.price + '€'
            if(item.data.discount != null)
                res = res + ' - Sconto: ' + item.data.discount + '%'
            if(item.data.um != null)
                res = res + ' - Um: ' + item.data.um?.name
            res = res + ']'
        }
        return res
    }
    override fill(filters: any) {
        super.fillBasicFilters(filters, 'PRODUCT')
        if(this.bomType != null) {
            filters.PRODUCT.bomType = this.bomType
        }
    }

    // @Input() @Output()
    // value: any
    onSelectionChange(ev) {
        this.selectionChanged.emit(ev)
    }

    get value(): any {
        return this.selectedEntries;
    }

    set value(value: any) {
        this.selectedEntries = value;
        if(value == null) {
            this.select.clearModel()
        }
    }

    updateEntries(value: any) {
        if(value) {
            const item = {
                id: value.id,
                name: value.businessName,
                disabled: value.state != 1,
                data: value
            } as unknown as ItemCrudInfo
            this.entries = [item];
            this.selectedEntries = item;
            this.select.itemsList.setItems(this.entries)
            this.select.select(this.select.itemsList.items[0])
        }
        else {
            this.entries = [];
            this.selectedEntries = null;
            this.select.itemsList.setItems(this.entries)
        }
    }


    @Input()
    set clearSearchOnAdd(value: boolean) {
        this.clearSearchOnAddVal = value;
    }

    @Input()
    set deselectOnClick(value: boolean) {
        this.deselectOnClickVal = value;
    }
}
